<template>
    <!--
        Combined layout for devices with screen dimensions that cover both mobile and desktop breakpoints.
        In details, if one of screen's dimension is wider than 991.98px, then the device can be rotated
        and therefore require both desktop and mobile components depending on the current screen size.
        !Important: Server side can render only combined layout with mobile components, since user agent
        is most likely mobileOrTablet (by nuxt-device). Client side is more flexible with regard to having specific
        window dimensions, therefore it happen that server is mobile while client is desktop. In this rare cases
        I left "bailing hydration" warnings untouched (in dev mode) since client side must perform full rerender anyway.
        Wrapping layout with <client-only> prevents server:mobile and client:mobile bundle cases from benefiting from ssr
    -->
    <div id="animod" :class="[priceModeCSS]">
        <media-only desktop class="header-wrapper">
            <Header v-if="showHeader" ref="header" />
            <Navigation v-if="showNavigation" />
        </media-only>

        <media-only mobile>
            <MainHeaderMobile :showNavigation="showMobileNavigation" />
        </media-only>

        <main id="main">
            <nuxt />
        </main>

        <div v-if="showNewsletter" class="container">
            <Newsletter id="newsletter-box" class="mt-5" ref="newsletter" />
        </div>

        <PriceModeToggle :is-checkout-route="isCheckoutRoute" />

        <template v-if="!isCheckoutRoute">
            <media-only :desktop="!showMobileSeparateFooter">
                <Footer />
            </media-only>
        </template>
        <media-only v-else :desktop="!showMobileSeparateFooter">
            <CheckoutFooter />
        </media-only>

        <client-only>
            <ToTopButton />
        </client-only>

        <FloatingBottom />
    </div>
</template>

<script>
import Header from '@/components/header/Header';
import MainHeaderMobile from '@/components/header/MainHeaderMobile';
import Navigation from '@/components/navigation/Navigation';
import Footer from '@/components/Footer';
import CheckoutFooter from '@/components/CheckoutFooter';
import authorizedLayout from '@/mixins/authorizedLayout';
import priceModeMixin from '@/mixins/priceModesGlobal';
import translatableLayout from '@/mixins/translatableLayout';
import themeableLayout from '@/mixins/themeableLayout';
import ToTopButton from '@/components/ToTopButton';
import PriceModeToggle from '@/components/PriceModeToggle';
import FloatingBottom from '@/components/layout/FloatingBottom';
import Newsletter from '@/components/newsletter/Newsletter';

export default {
    name: 'CombinedLayout',
    mixins: [priceModeMixin, authorizedLayout, translatableLayout, themeableLayout],
    components: {
        Newsletter,
        FloatingBottom,
        PriceModeToggle,
        Header,
        MainHeaderMobile,
        Navigation,
        Footer,
        CheckoutFooter,
        ToTopButton
    }
};
</script>
